import styled from "styled-components";

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  span {
    color: var(--purple);
    font-size: var(--fs-md);
  }

  h4 {
    color: var(--white);
    font-size: var(--fs-md);
  }
`;